module.exports = __webpack_public_path__ + "static/img/Jai-Murray .7b51ee3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jai-Murray .jpg
// module id = YCLg
// module chunks = 0